import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from "react-router-dom";
import './index.css';
import App from './App.tsx';
import * as serviceWorker from './serviceWorker';
import { debounce } from 'lodash'

import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey("SDS_Mechanical__Automation_SDSMA_multi_2_Devs__6_January_2021_[v2]_MTYwOTg5MTIwMDAwMA==fe67df600eb759074885c4c2eb801f7c");

const appHeight = () => {
  let iH = window.innerHeight;
  document.documentElement.style.setProperty('--innerHeight', `${iH}px`)
}

window.addEventListener('resize', debounce(appHeight, 100))
appHeight()

ReactDOM.render(<Router><App key="app" /></Router>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
